module.exports = __webpack_public_path__ + "img/enseption_05.59774f24.png";